import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'te', label: 'తెలుగు' },
];

export default function LanguageSwitcher({ className = '' }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const select = (code) => {
    changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className={`lang-switcher ${className}`}>
      <button type="button" className="navbar-action-btn lang-switcher-btn" onClick={() => setOpen(!open)} aria-label="Change language">
        🌐 {current.label}
      </button>
      {open && (
        <>
          <div className="lang-switcher-backdrop" onClick={() => setOpen(false)} />
          <div className="lang-switcher-menu">
            {LANGUAGES.map(l => (
              <button
                type="button"
                key={l.code}
                className={`lang-switcher-option${l.code === i18n.language ? ' active' : ''}`}
                onClick={() => select(l.code)}
              >
                {l.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
